{
  "ACTION": {
    "CLEAR_FILTER": "Borrar",
    "CONTINUE": "Continuar",
    "EDIT": "Modificar",
    "SEND": "Enviar",
    "VALIDATE": "Validar"
  },
  "ARIA": {
    "MENU": "Menú principal"
  },
  "COMPONENT": {
    "AGENDA-MAGASIN-TUNNEL": {
      "I_WANT_TO_TAKE_MY_APPOINTMENT": "Vull fer la meva cita",
      "IN_STORE": "A la botiga",
      "REMOTELY": "En videotrucada"
    },
    "AVIS-GOOGLE": {
      "OUT_OF": "de",
      "REVIEWS": "Reseñas"
    },
    "AVIS-GOOGLE-DETAILS": {
      "AVERAGE_RATING_DISCLAIMER": "Esta puntuación se ha calculado a partir de las <strong>{{nbReviews}} opiniones publicadas en Google*</strong> por nuestros clientes tras su experiencia en nuestras tiendas SoCoo'c en toda Francia. *Estas opiniones no han sido verificadas.",
      "AVERAGE_RATING_DISCLAIMER_STORE": "Aquesta puntuació s'ha obtingut recopilant les <strong>{{nbReviews}} ressenyes de Google*</strong> que els nostres clients han deixat a la nostra botiga després de la seva experiència amb SoCoo'c. *Les nostres ressenyes de Google no han estat verificades.",
      "REVIEWS_STAR": "Las reseñas de {{count}} estrella:",
      "REVIEWS_STARS": "Las reseñas de {{count}} estrellas:",
      "SEE_MORE_REVIEWS": "Ver más opiniones",
      "SORT_BY_HIGHEST_TO_LOWEST_RATED": "De mejor valorado a peor valorado:"
    },
    "CARTE-OPPORTUNITES": {
      "OPENING_OPPORTUNITIES": "Oportunitats d’obertura",
      "OVERSEAS_OPPORTUNITIES": "Les nostres oportunitats internacionals",
      "STORES_OPEN": "Botigues obertes"
    },
    "CONFIRMATION-RDV": {
      "THANK_YOU_RESPONSE": "Gràcies per la seva resposta"
    },
    "CONFIRMATION-RDV-ESPACE-CLIENT": {
      "ADD_TO_CALENDAR": "Afegir al meu calendari",
      "CALENDAR_EVENT_TITLE": "Cita {{store}}",
      "IMPEDIMENT_TITLE": "Algun imprevist?",
      "IMPEDIMENT_TEXT": "Avisa'ns perquè no preparem el cafè massa aviat ;) És molt senzill amb la teva àrea de client SoCoo'c: pots modificar o cancel·lar la teva cita.",
      "CREATE_ACCOUNT": "Creo el meu compte SoCoo'c",
      "LOGIN": "Inicio sessió",
      "MY_ACCOUNT": "Accedeixo al meu compte SoCoo'c"
    },
    "CONTENU-ARTICLE": {
      "MINUTE": "{{count}} minuto",
      "MINUTES": "{{count}} minutos",
      "READING_TIME_LABEL": "Tiempo de lectura:"
    },
    "ENCART-INFOS-MAGASIN": {
      "CLOSED": "Cerrado",
      "EXCEPTIONAL_CLOSURE": "Cierre excepcional",
      "EXCEPTIONAL_OPENING": "Apertura excepcional",
      "SHOW_ALL_REVIEWS": "Ver todas las reseñas"
    },
    "ESTIMATEUR-BUDGET-DETAIL-PRIX": {
      "CALCULATING_CURRENT_PRICE": "Cálculo del precio en curso",
      "DELIVERY_INCLUDED": "Entrega incluida",
      "PRICE_BREAKDOWN_DETAIL": "Detalle del precio",
      "STARTING_FROM_PER_MONTH": "Desde {{price}}/mois"
    },
    "ESTIMATEUR-BUDGET-SELECTION": {
      "ESTIMATION_INDEX": "Estimación {{ index }}",
      "HOUSEHOLD_APPLIANCE": "Electrodomèstics",
      "MY_ESTIMATIONS": "Mis estimaciones",
      "MY_SELECTION": "La meva selecció",
      "PRICE_RANGE": "Entre {{ minPrice }} y {{ maxPrice }}",
      "REQUEST_NEW_ESTIMATE": "Nueva estimación",
      "SEND_BY_EMAIL": "Enviar por correo electrónico"
    },
    "ESTIMATEUR-ETAPE": {
      "HEADER": {
        "APPLIANCES_AND_PLUMBING_LABEL": "Electrodomèstics i sanitaris",
        "DELIVERY_AND_INSTALLATION_LABEL": "Lliurament i instal·lació",
        "FURNITURE_LABEL": "Mobles",
        "PRICE_ESTIMATE_LABEL": "Estimació"
      },
      "I_DONT_NEED_ANYTHING": "No necesito nada"
    },
    "FORMULAIRE-CATALOGUE": {
      "CATALOG_SENT_TO_EMAIL": "Tu catálogo ha sido enviado por email a la dirección {{ email }}.",
      "CATALOG_WAITING_IN_MAILBOX": "Tu catálogo te espera en tu correo.",
      "CHECK_SPAM_IF_NOT_RECEIVED": "Si tras unos minutos no lo has recibido, revisa tu carpeta de spam.",
      "DOWNLOAD_CATALOG": "Descargar el catálogo",
      "FORM_ERROR": "Error al enviar el formulario.",
      "LABEL_EMAIL": "Mi correo electrónico:"
    },
    "FORMULAIRE-CONTACT-B2B": {
      "DEVELOPER_SECTION_DESCRIPTION": "Seleccioneu el departament d'implantació desitjat per descobrir qui és el vostre desenvolupador a càrrec",
      "DEVELOPER_SECTION_TITLE": "El nostre equip de desenvolupament al vostre servei!",
      "LABEL_AREA": "Departament d'implantació:",
      "LABEL_EMAIL": "La meva adreça de correu:",
      "LABEL_FIRST_NAME": "El meu nom:",
      "LABEL_LAST_NAME": "El meu cognom:",
      "LABEL_MESSAGE": "Un missatge per als nostres desenvolupadors:",
      "LABEL_PHONE": "El meu número de telèfon:",
      "MESSAGE_CONFIRMATION_RESPONSE_SOON": "El seu missatge ha estat transmès als nostres equips, li respondrem en breu.﻿",
      "MESSAGE_HELPER_TEXT": "Doneu-nos alguns detalls sobre el vostre projecte: ciutat(s) d'implantació desitjada(es), les vostres experiències, ..."
    },
    "FORMULAIRE-RDV": {
      "FORM_PLACEHOLDER_MESSAGE": "Ja ha conegut algun dels nostres Kitcheners o li agradaria conèixer-ne un en particular?\nTé un projecte de cuina? O necessita informació?",
      "LABEL_APPOINTMENT": "Tu cita:",
      "LABEL_APPOINTMENT_DATETIME": "a las",
      "LABEL_CUSTOM_MESSAGE": "¿Un mensaje personalizado?",
      "LABEL_STORE_LOCATION": "En tu tienda ",
      "LABEL_WHEN": "Cuándo",
      "LABEL_WHERE": "Dónde",
      "VIDEO_APPOINTMENT_WITH_STORE": "En videollamada con tu tienda"
    },
    "HERO-MODELE": {
      "ALL_OUR_FINISHES": "Todos nuestros acabados",
      "KITCHEN_LAYOUT_WITH_SURFACE": "Cocina {{type}} de {{surface}}"
    },
    "HERO-SLIDER": {
      "VIRTUAL_TOUR": "Visita virtual"
    },
    "KITCHEN-MODEL-CARD": {
      "SEE_THIS_KITCHEN": "Ver esta cocina"
    },
    "LISTING-AUTRES-FACADES": {
      "OTHER_FRONTS": "Los otros frentes"
    },
    "LISTING-COIN-REPAS": {
      "FROM": "Desde:",
      "PER_UNIT": "la unidad"
    },
    "LISTING-FACADES": {
      "NO_RESULTS": "Cap resultat per a aquest tipus de façana."
    },
    "LISTING-MAGASIN": {
      "SEE_THIS_STORE": "Veure aquesta botiga"
    },
    "LISTING-MEUBLES-IMAGE-NOM-DESCRIPTION": {
      "AVAILABLE_HEIGHTS": "Alturas disponibles",
      "AVAILABLE_WIDTHS": "Anchuras disponibles"
    },
    "LISTING-PACK-PRODUITS": {
      "FOR_THE_SET": "El lote",
      "INSTEAD_OF": "En vez de:"
    },
    "LISTING-TEMOIGNAGES": {
      "SEE_MORE_TESTIMONIES": "Veure més testimonis"
    },
    "MAP-POPIN": {
      "WANT_TO_KNOW_MORE_OPPORTUNITY": "Vols saber-ne més sobre aquesta oportunitat?"
    },
    "MENU-BLOG": {
      "THE_BLOG": "El blog",
      "THE_SECTIONS": "Los temas"
    },
    "MENU-TUNNEL": {
      "CONTACT_DETAILS": "Contacto",
      "DAY_AND_TIME": "Días y horario",
      "STORE": "Tienda"
    },
    "POPIN-ESTIMATION-EMAIL": {
      "ALL_GOOD": "¡Todo listo!",
      "ESTIMATE_SENT_CONFIRMATION": "&lt;p&gt;Su estimación le ha sido enviada por correo electrónico a la dirección  {{email}}.&lt;/p&gt;&lt;p&gt;Si después de unos minutos no la ha recibido, compruebe la carpeta de spam.&lt;/p&gt;",
      "MY_EMAIL_ADDRESS": "Mi dirección de correo electrónico",
      "PRIVACY_POLICY_REMINDER": "Para saber cómo utilizamos los datos recopilados en este formulario y ejercer sus derechos sobre sus datos personales, especialmente de acceso y supresión, consulte nuestra &lt;strong&gt;&lt;a target=\"_blank\"  class=\"cursor-pointer\" href=\"{{privacyPolicyUrl}}\"&gt;política de privacidad&lt;/a&gt;&lt;/strong&gt;.",
      "SEND_ESTIMATE": "Enviar la estimación",
      "SEND_KITCHEN_ESTIMATE_BY_EMAIL": "Enviar la estimación de mi cocina por correo electrónico"
    },
    "POPIN-PRICE-DETAIL": {
      "LOADING_PRICE_DETAILS": "Cargando el detalle del precio"
    },
    "POPIN-REALISATIONS-CLIENTS": {
      "CREATED_BY": "Realitzada per:",
      "NEXT_KITCHEN": "Cuina següent",
      "PREVIOUS_KITCHEN": "Cuina anterior"
    },
    "SEARCH": {
      "LABEL_MY_CITY": "Localitat"
    },
    "STORE-LOCATOR": {
      "BOOK_APPOINTMENT": "Pedir cita",
      "DISTANCE_IN_KM": "A {{km}} km",
      "PLACEHOLDER_CITY_OR_POSTAL_CODE": "Ciudad o código postal",
      "SELECT_THIS_STORE": "Elegir esta tienda",
      "VIDEO_APPOINTMENT_AVAILABLE": "Cita videollamada disponible"
    },
    "TEXTE-SEO": {
      "SEE_LESS": "Mostrar menos",
      "SEE_MORE": "Mostrar más"
    },
    "TITRE-FILTRES-MODELES": {
      "BUDGET_PLACEHOLDER": "Presupuesto",
      "CHOOSE_ACTION": "Yo elijo",
      "KITCHEN_FRONTS_PLACEHOLDER": "los frentes",
      "KITCHEN_LAYOUT": "mi distribución",
      "LAYOUT_PLACEHOLDER": "Distribución",
      "OUR_SELECTION": "Nuestra selección",
      "PRICE_ASCENDING": "De menor a mayor precio",
      "PRICE_DESCENDING": "De mayor a menor precio",
      "PRICE_LESS_THAN": "Menos de {{amount}} €",
      "PRICE_MORE_THAN": "Más de {{amount}} €",
      "PRICE_RANGE": "Entre {{min}} € y {{max}} €",
      "PS_LOVE": "PD: Me encanta",
      "RESET_FILTERS": "Restablecer filtros",
      "SEARCH_KITCHEN": "Busco una cocina"
    }
  },
  "ELASTIC_SEARCH": {
    "GET-CABINET-BODIES-QUERY": {
      "CABINET_BODY": "Cuerpos de mueble"
    },
    "GET-COUNTERTOPS-QUERY": {
      "WORKTOPS": "Encimeras"
    },
    "GET-FRONTS-QUERY": {
      "KITCHEN_FRONTS": "Frentes"
    },
    "GET-HANDLES-QUERY": {
      "HANDLES": "Tiradores"
    }
  },
  "GLOBAL": {
    "AND": "Y",
    "APPLIANCES_AND_SANITARY": "Electrodomésticos y sanitarios",
    "BACK": "Volver",
    "BETWEEN": "Entre",
    "BUDGET": "Presupuesto:",
    "CALL_TO_ACTION_CALL_US": "Llámanos",
    "CONTACT_STORE_FOR_AVAILABLE_APPOINTMENTS": "Llama a {{storeName}} al &lt;strong&gt;&lt;a href=\"{{storePhoneTelLink}}\" style=\"white-space: nowrap;\"&gt;{{storePhoneFormatted}}&lt;/a&gt;&lt;/strong&gt; para saber qué citas hay disponibles",
    "CONTACT_STORE_FOR_AVAILABLE_APPOINTMENTS_NO_PHONE": "Contacta amb {{storeName}} per saber quines cites hi ha disponibles",
    "CONTACT_US": "Contacta’ns",
    "FIELD_MIN_LENGTH_ERROR": "Por favor, introduzca al menos 3 caracteres",
    "FINISHES": "Acabados",
    "FORMS": {
      "APPOINTMENT_SERVER_ERROR": "El servei de cites no està disponible en aquest moment. Us recomanem que truqueu a la botiga al {{phone}} o que torneu a intentar-ho d'aquí a uns minuts.",
      "APPOINTMENT_SERVER_ERROR_NO_PHONE": "El servei de cites no està disponible en aquest moment. Us recomanem que torneu a intentar-ho d'aquí a uns minuts.",
      "AREA_REQUIRED_ERROR": "El departament és obligatori",
      "CALLBACK_REQUEST_PROMPT": "¿Quieres que te llamemos?",
      "CHECKBOX_REQUIRED_ERROR": "Debes marcar al menos una opción",
      "CITY_REQUIRED_ERROR": "La ciudad es obligatoria",
      "EMAIL_INVALID_ERROR": "El correo electrónico no es válido",
      "EMAIL_REQUIRED_ERROR": "El correo electrónico es obligatorio",
      "FIRST_NAME_MIN_LENGTH_ERROR": "El nombre debe tener al menos 3 caracteres",
      "GENDER_REQUIRED_ERROR": "El género es obligatorio",
      "INTEREST_REQUIRED_ERROR": "El motiu del seu interès és obligatori",
      "LABEL_CITY": "Ciudad:",
      "LABEL_EMAIL": "Correo electrónico:",
      "LABEL_FIRST_NAME": "Nombre:",
      "LABEL_INFORMATION_TYPE": "Tipus d'informació:",
      "LABEL_LAST_NAME": "Apellido:",
      "LABEL_MESSAGE": "Mensaje:",
      "LABEL_NEWSLETTER_OPTIN": "¿Deseas recibir noticias y ofertas de SoCoo'c?",
      "LABEL_OPTIN_EMAIL": "Por correo electrónico",
      "LABEL_OPTIN_SMS": "Por SMS",
      "LABEL_PHONE": "Telèfon:",
      "LABEL_REQUEST_TYPE": "Tipo de solicitud:",
      "LABEL_STORE": "Botiga",
      "LABEL_TITLE_MADAM": "Señora",
      "LABEL_TITLE_MISTER": "Señor",
      "LABEL_ZIPCODE": "Código postal:",
      "LAST_NAME_MIN_LENGTH_ERROR": "El apellido debe tener al menos 2 caracteres",
      "MESSAGE_RECEIVED_CONFIRMATION": "Hemos recibido tu mensaje. ¡Te responderemos lo antes posible!",
      "MESSAGE_REQUIRED_ERROR": "El mensaje es obligatorio",
      "PHONE_FORMAT_ERROR": "El número de teléfono no tiene un formato válido",
      "PHONE_REQUIRED_ERROR": "El número de teléfono es obligatorio",
      "REQUEST_INFORMATION_TYPE_REQUIRED_ERROR": "Debes indicar el tipo de información",
      "REQUEST_ORDER_TYPE_REQUIRED_ERROR": "Cal indicar la botiga",
      "REQUEST_TYPE_REQUIRED_ERROR": "El tipo de solicitud es obligatorio",
      "ZIPCODE_FORMAT_ERROR": "El código postal no tiene un formato válido",
      "ZIPCODE_NOT_FOUND_ERROR": "Codi postal no reconegut, si us plau introduïu un altre codi postal",
      "ZIPCODE_REQUIRED_ERROR": "El código postal es obligatorio"
    },
    "FURNITURE": "Muebles",
    "INCLUDING_ECO_PART": "incluidos {{price}} de ecoparticipación",
    "INCLUDING_X_ENVIRONMENTAL_TAX": "incluyendo {{environmentalTaxPrice}} de tasa ecológica",
    "INSTALLATION_AND_DELIVERY": "Instalación y entrega",
    "KITCHEN": "Cocina",
    "LOADING_OPENING_HOURS": "Cargando los horarios",
    "LOADING_TIME_SLOTS": "Cargando los horarios",
    "NO": "No",
    "PUNCTUATION": {
      "COLON": ":"
    },
    "SEE_MORE": "Mostrar más",
    "SEE_MORE_TIME_SLOTS": "Ver más horarios disponibles",
    "STORE_CLOSED_TODAY": "Cerrado hoy",
    "STORE_OPEN_TODAY": "Abierto hoy",
    "VIEW_PRICE_DETAILS": "Ver el detalle del precio",
    "YES": "Sí"
  },
  "MIDDLE_OFFICE": {
    "LOGOUT": "Cerrar sesión"
  },
  "PRICE": {
    "ECO_PART": "incluidos {{ecoPart}} de eco-participación"
  },
  "SCHEMA_JSON_LD": {
    "BLOG_MENU": "Menú del blog",
    "FOOTER_MENU": "Menú del peu de pàgina",
    "MAIN_MENU": "Menú principal"
  }
}
